import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ICompaniesResponse {
  success: boolean;
  message: string;
  data: ICompany[];
}

export interface ICompany {
  id: number;
  nameCompany: string;
}

interface ICompaniesState {
  companies: ICompany[];
  message: string;
  success: boolean;
}

const initialState: ICompaniesState = {
  companies: [],
  message: "",
  success: false,
}

export const companiesSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    loadCompanies(state, action: PayloadAction<ICompaniesResponse>) {
      state.companies = action.payload.data;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    diMissCompanies(state) {
      state.companies = [];
      state.message = "";
      state.success = false;
    },
  },
});

export const { loadCompanies, diMissCompanies } = companiesSlice.actions;

export default companiesSlice.reducer;